import { useContext, useState } from "react"
import { AppContext } from "../../context/AppContext"
import { MapContext } from "../../context/MapContext";
import {
	Tooltip,
	IconButton,
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import * as olProj from 'ol/proj';
import GeoJSON from 'ol/format/GeoJSON';
import axios from 'axios';
import { bgMapObject, inflowBgLayers, inflowLayers, inoutflowBgLayers, inoutflowLayers, outflowBgLayers, outflowLayers } from "../map/layers";
import { cql2filter } from "../../common/func/cql2filter";
import { abstractFetch } from "../../common/func/abstractFetch";

export default function SelectOption() {
  const {step, setStep, mapMode, setMapMode, execFunctionLog} = useContext(AppContext);
  const { inflowIndex, setInflowIndex, 
					inflowIndexInput, setInflowIndexInput, 
          outflowIndex, setOutflowIndex, 
					outflowIndexInput, setOutflowIndexInput,
          setInPopupOpen, setInPopupData, setInPopupPosition,
          setOutPopupOpen, setOutPopupData, setOutPopupPosition,
					setInOutPopupOpen, setInOutPopupData, setInOutPopupPosition,
					handleInflowIndexInput, handleOutflowIndexInput,
          inflowMapRef, outflowMapRef,
					inoutflowMapRef
        } = useContext(MapContext);

  const [prevControlOpen, setPrevControlOpen] = useState(true);

  const onClickInoutHub = () => {
		setStep(2);
		setMapMode('inout');
		setInflowIndex(0.035);
		setInflowIndexInput(0.035);
		setOutflowIndex(0.03);
		setOutflowIndexInput(0.03);

		setInPopupOpen(false);
		setInPopupData({
			pc_grid_nm: '',
			pc_pop_w: 0,
			pc_pop_r: 0,
			pc_in_val: 0,
			pc_out_val: 0,
		});
		setInPopupPosition({ x: 0, y: 0 });
		setOutPopupOpen(false);
		setOutPopupData({
			pc_grid_nm: '',
			pc_pop_w: 0,
			pc_pop_r: 0,
			pc_in_val: 0,
			pc_out_val: 0,
		});
		setOutPopupPosition({ x: 0, y: 0 });

		inoutflowMapRef.current
			.getView()
			.setCenter(
				olProj.transform([128.0292, 36.6332], 'EPSG:4326', 'EPSG:3857')
			);
		inoutflowMapRef.current.getView().setZoom(7.3);

		Object.values(bgMapObject).forEach((name) => {
			inoutflowBgLayers[name].setVisible(false);
			inoutflowBgLayers.bgMidNightLayer.setVisible(true);
		});

		inoutflowLayers.bgEmdLayer.setVisible(false);
		inoutflowLayers.bgSidoLayer.setVisible(false);
		inoutflowLayers.centralHubT.setVisible(true);
		inoutflowLayers.centralHubV.setVisible(true);
	};

	const onClickPrevious = () => {
		setStep(1);
		setMapMode('dual');
		setInflowIndex(0.035);
		setInflowIndexInput(0.035);
		setOutflowIndex(0.03);
		setOutflowIndexInput(0.03);
		setInOutPopupOpen(false);
		setInOutPopupData({
			pc_grid_nm: '',
			pc_pop_w: 0,
			pc_pop_r: 0,
			pc_in_val: 0,
			pc_out_val: 0,
		});
		setInOutPopupPosition({ x: 0, y: 0 });

		inflowMapRef.current
			.getView()
			.setCenter(
				olProj.transform([128.0292, 36.6332], 'EPSG:4326', 'EPSG:3857')
			);
		inflowMapRef.current.getView().setZoom(7.3);
		outflowMapRef.current
			.getView()
			.setCenter(
				olProj.transform([128.0292, 36.6332], 'EPSG:4326', 'EPSG:3857')
			);
		outflowMapRef.current.getView().setZoom(7.3);

		Object.values(bgMapObject).forEach((name) => {
			inflowBgLayers[name].setVisible(false);
			outflowBgLayers[name].setVisible(false);

			inflowBgLayers.bgMidNightLayer.setVisible(true);
			outflowBgLayers.bgMidNightLayer.setVisible(true);
		});

		inflowLayers.bgEmdLayer.setVisible(false);
		inflowLayers.bgSidoLayer.setVisible(false);
		inflowLayers.centralHubT.setVisible(true);
		inflowLayers.centralHubV.setVisible(true);

		outflowLayers.bgEmdLayer.setVisible(false);
		outflowLayers.bgSidoLayer.setVisible(false);
		outflowLayers.centralHubT.setVisible(true);
		outflowLayers.centralHubV.setVisible(true);
	};


  const handleMapMode = (e) => {
		const value = e.target.value;
		if (value === 'in') {
			execFunctionLog('유입 중심성 지수별 거점 분석', '지도 모드 변경 기능 제공');
			setOutPopupOpen(false);
			setOutPopupData({
				pc_grid_nm: '',
				pc_pop_w: 0,
				pc_pop_r: 0,
				pc_in_val: 0,
				pc_out_val: 0,
			});
			setOutPopupPosition({ x: 0, y: 0 });
		} else if (value === 'out') {
			execFunctionLog('유출 중심성 지수별 거점 분석', '지도 모드 변경 기능 제공');
			setInPopupOpen(false);
			setInPopupData({
				pc_grid_nm: '',
				pc_pop_w: 0,
				pc_pop_r: 0,
				pc_in_val: 0,
				pc_out_val: 0,
			});
			setInPopupPosition({ x: 0, y: 0 });
		};
		setMapMode(value);
	};

	const onClickInOutflowIndexBtn = () => {
		execFunctionLog('유입⋅유출 중심성 지수별 거점 분석', '유입⋅유출 중심성 지수 설정 및 분석 기능 제공');
		const fetchXmlString = async (inflowIndex, outflowIndex) => {
			const indexXmlString = await cql2filter(
				'pc_in_val>=' + inflowIndex + 'and pc_out_val>=' + outflowIndex
			);
	
			const indexFeatureRequest = {
				service: 'WFS',
				version: '1.0.0',
				request: 'GetFeature',
				outputFormat: 'application/json',
				srsName: 'EPSG:3857',
				typeName: 'pinogio:flow_pc_grid_2021',
				filter: indexXmlString,
			}; 
	
			abstractFetch(indexFeatureRequest)
				.then((res) => {
					inoutflowLayers.centralHubV.getSource().clear();
					inoutflowLayers.centralHubV
						.getSource()
						.addFeatures(new GeoJSON().readFeatures(res));
				})
				.catch((err) => console.log(err));
	
			inoutflowLayers.centralHubV.getSource().refresh();
			inoutflowLayers.centralHubV.setVisible(true);
	
			inoutflowLayers.centralHubT.getSource().updateParams({
				filter: await cql2filter(`pc_in_val>=${inflowIndex} and pc_out_val>=${outflowIndex}`),
			});
			inoutflowLayers.centralHubT.getSource().refresh();
			inoutflowLayers.centralHubT.setVisible(true);
		}
		fetchXmlString(inflowIndex, outflowIndex);
	};

  return (
    <div>
      {step === 1 ? (
					<div
					className={
						prevControlOpen
						? 'mapSelectWrap subSelectWrap'
						: 'mapSelectWrap subSelectWrap hide1'
					}
					>
						<div
							className="hideBtn"
							onClick={() => setPrevControlOpen(!prevControlOpen)}
							>
							<img src="./img/leftMenuHideBtn.png" alt="닫기" />
						</div>

						<button className="inoutHubBtn" onClick={onClickInoutHub}>
							유입 + 유출 거점 보기
						</button>

						<div className="dotLine"></div>

						<h2 className="mapSelectTit">
							· 지도 모드 선택
							<Tooltip
								title="지도 모드를 선택하면 해당 모드로 전환됩니다."
								placement="right"
								className="infoTooltip"
								>
								<IconButton size="small">
									<InfoIcon className="infoTooltipIcon"></InfoIcon>
								</IconButton>
							</Tooltip>
						</h2>
						<div className="regionChecked">
							<label>
								<input
									type="radio"
									name="mapMode"
									value="dual"
									checked={mapMode === 'dual'}
									onChange={handleMapMode}
									/>
								유입/유출 분할 모드
							</label>
							<label>
								<input
									type="radio"
									name="mapMode"
									value="in"
									checked={mapMode === 'in'}
									onChange={handleMapMode}
									/>
								유입 중심 거점
							</label>
							<label>
								<input
									type="radio"
									name="mapMode"
									value="out"
									checked={mapMode === 'out'}
									onChange={handleMapMode}
									/>
								유출 중심 거점
							</label>
						</div>
					</div>
				) : null}
			{step === 2 ? (
						<div
							className={
								prevControlOpen
									? 'mapSelectWrap subSelectWrap'
									: 'mapSelectWrap subSelectWrap hide2'
							}
						>
							<div
								className="hideBtn"
								onClick={() => setPrevControlOpen(!prevControlOpen)}
							>
								<img src="./img/leftMenuHideBtn.png" alt="닫기" />
							</div>

							<button className="previousBtn" onClick={onClickPrevious}>
								<img
									src="img/previousBtn.png"
									alt="유입 + 유출 중심 거점 보기"
								/>
								유입 / 유출 중심 거점 보기
							</button>

							<div className="dotLine"></div>

							<h4 className="mapSelectTit">
								유입+유출 거점 추출하기
								<Tooltip
									title="유입 중심성 지수와 유출 중심성 지수를 각각 입력 후 '선택' 버튼을 클릭하면 해당 값 이상의 격자(들)의 교집합 영역이 나타납니다."
									placement="right"
									className="infoTooltip"
								>
									<IconButton size="small">
										<InfoIcon className="infoTooltipIcon"></InfoIcon>
									</IconButton>
								</Tooltip>
							</h4>
							<div className="flowInput">
								<div className="inflowInput">
									<h2 className="boxTit">· 유입 중심성 지수 입력</h2>
									<input
										className="densityNum orangeText"
										type="number"
										step={0.001}
										min={0.0}
										max={65.868}
										value={inflowIndexInput}
										onChange={handleInflowIndexInput}
									/>
									<span>이상</span>
									<div className="detail info3">
										<span>* 0 이상 65.868 이하 값 입력 가능</span>
									</div>
								</div>
								<div className="outflowInput">
									<h2 className="boxTit">· 유출 중심성 지수 입력</h2>
									<input
										className="densityNum blueText"
										type="number"
										step={0.001}
										min={0.0}
										max={16.054}
										value={outflowIndexInput}
										onChange={handleOutflowIndexInput}
									/>
									<span>이상</span>
									<div className="detail info3">
										<span>* 0 이상 16.054 이하 값 입력 가능</span>
									</div>
								</div>
							</div>
							<div className="btn">
								<button
									className="searchBtn"
									onClick={onClickInOutflowIndexBtn}
								>
									선택
								</button>
							</div>
						</div>
					) : null}
    </div>
  )
}